import { render, staticRenderFns } from "./desktopDot.vue?vue&type=template&id=5a9464e2&scoped=true&"
import script from "./desktopDot.vue?vue&type=script&lang=js&"
export * from "./desktopDot.vue?vue&type=script&lang=js&"
import style0 from "./desktopDot.vue?vue&type=style&index=0&id=5a9464e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9464e2",
  null
  
)

export default component.exports